import React, { useState, useEffect } from 'react'
import { useNavigate , useSearchParams } from 'react-router-dom'
import axios from 'axios'
import URL from '../constants/ServerUrl'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'
import { formatDateInAD, formatDateInBS } from '../utils/formatDate'


const EditCollection = ({ route }) => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const Id=searchParams.get('Id')
  const [date, setDate] = useState(new Date())
  const [totalAmt, setTotalAmt] = useState(-1)
  const [rate, setRate] = useState(8)
  const [qty, setQty] = useState('')
  const [fat, setFat] = useState('')
  const [snf, setSnf] = useState('')
  const [farmerName, setFarmerData] = useState('nitin')
  const [farmerId, setFarmerId] = useState(-1)
  const [selectedOption, setSelectedOption] = useState('Morning')
  const [isPickerShow, setIsPickerShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [printLoading, setPrintLoading] = useState(false)
  const [collectionDetails, setCollectionDetails] = useState({});
  const token = localStorage.getItem("dairy-token")

  const [isDeleting, setIsDeleting] = useState(false)
  const navigator = useNavigate()

  const showPicker = () => {
    setIsPickerShow(true)
  }

  const onChange = ( value) => {
    setDate(value)
  
    }
  

    const getCollectionById = async () => {
      try {
        console.log(Id);
        console.log(username);
        const response = await axios.get(`${URL}admin/${username}/collection/${Id}`,{
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(response);
        const collection = response.data;
        console.log(collection);
    
        // Set the fetched data to state variables
        setTotalAmt(collection.amount);
        setDate(new Date(collection.collectionDate));
        setFarmerData(collection.farmerName);
        setFarmerId(collection.farmerId);
        setRate(collection.rate);
        setQty(collection.qty);
        setFat(collection.fat);
        setSnf(collection.snf);
        setSelectedOption(collection.shift);
        
    
      } catch (error) {
        console.error("Error fetching collection data:", error);
      }
    };
  
    // useEffect to call getCollectionById when the component mounts
    useEffect(() => {
      if (username && Id) {
        getCollectionById();
      }
    }, [username, Id]); // Depend on username and Id to re-fetch when they change
  
    // ... [rest of your component]
    
  const deleteCollection = async () => {
    try {
      if (username) {
        setIsDeleting(true)
        const collectionResponse = await axios.delete(`${URL}admin/${username}/collection/${Id}?shift=${selectedOption}&date=${date}`,{
          Authorization: `Bearer ${token}`,
        })
        if (collectionResponse.status === 200) {
          setIsLoading(false)
          alert('Collection Deleted Successfully')
          navigator('/')
        }
      }
    } catch (err) {
      setIsDeleting(false)
      alert('Error deleting collection')
      console.log(err)
    }
  }

  const updateCollection = async () => {
    try {
      if (username) {
        setIsLoading(true);
  
        getCollectionById();
        const payload = {
          amount: Number(totalAmt),
          collectionDate: date,
          farmerName: farmerName,
          farmerId: farmerId,
          rate: rate,
          qty: qty,
          fat: fat,
          snf: snf,
          shift: selectedOption
        };
  
        const collectionResponse = await axios.put(`${URL}admin/${username}/collection/${Id}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
  
        if (collectionResponse.status === 200) {
          setIsLoading(false);
          alert('Collection Updated Successfully');
      
        }
      }
      navigator(-1);
    } catch (err) {
      setIsLoading(false);
    
      // Check if the error response and data are defined
      if (err.response && err.response.data && err.response.data.message) {
        alert(err.response.data.message);
      } else {
        // Fallback error message
        alert("An error occurred while updating the collection.");
      }
    
      console.log(err);
    }
  };

  const Item = ({ farmerId, farmerName, farmerLevel }) => (
    <div >
      <div>{farmerId}</div>
      <div >{farmerName}</div>
      <div >{farmerLevel}</div>
    </div>
  )
  return (


    <div className="container mx-auto p-4">
    <div className="flex justify-between mb-4">
      <div className="flex items-center space-x-2">
        <button
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          onClick={() => setSelectedOption('Morning')}
        >
          Choose Morning
        </button>
        <span className="text-gray-700">Morning</span>
      </div>
  
      <button
        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
        onClick={() => setSelectedOption('Evening')}
      >
        Evening
      </button>
    </div>
  
    <div className="bg-white shadow rounded-lg p-4 mb-4">
      <div className="flex items-center space-x-2 mb-2">
        <div className="text-gray-700 font-semibold">FARMER NAME:</div>
        <div>{farmerName}</div>
      </div>
  
      <div className="flex items-center space-x-2 mb-2">
        <div className="text-gray-700 font-semibold">FARMER ID:</div>
        <div>{farmerId}</div>
      </div>
  
      <div className="flex items-center space-x-2 mb-2">
        <div className="text-gray-700 font-semibold">Total Amount:</div> 
        <div>{totalAmt}</div>
        <div className="text-gray-700 font-semibold">Rate:</div>
        <div>{rate}</div>
      </div>
  
      <div>
        <div>
          {!isPickerShow && (
            <div className="mb-2">
              <button className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600" onClick={showPicker}>
                <div>{formatDateInAD(date)}</div>
              </button>
            </div>
          )}
  
          {isPickerShow && (
            <NepaliDatePicker
              inputClassName="form-control"
              className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
              value={date}
              onChange={onChange}
              options={{ calenderLocale: 'en', valueLocale: 'en' }}
            />
          )}
        </div>
  
        <input
          className="border border-gray-300 rounded px-4 py-2 w-full mb-2"
          placeholder='Enter Quantity'
          value={qty > 0 ? qty.toString() : ''}
          onChange={(text) => {
            setQty(text.target.value);
            setTotalAmt((text * rate).toFixed(2));
          }}
        />
  
        <input
          className="border border-gray-300 rounded px-4 py-2 w-full mb-2"
          placeholder='Enter fat'
          value={fat > 0 ? fat.toString() : ''}
          onChange={(text) => setFat(text.target.value)}
        />
  
        <input
          className="border border-gray-300 rounded px-4 py-2 w-full mb-4"
          placeholder='enter SNF'
          value={snf > 0 ? snf.toString() : ''}
          onChange={(text) => setSnf(text.target.value)}
        />
  
        <button
          className={`px-4 py-2 rounded ${isLoading ? 'bg-gray-500' : 'bg-blue-500 hover:bg-blue-600'} text-white`}
          onClick={() => {
            if (!isLoading) {
              updateCollection();
            }
          }}
          disabled={isLoading}
        >
          {isLoading ? 'Updating...' : 'Update Collection'}
        </button>
  
        <button
          className={`px-4 py-2 rounded ml-2 ${isDeleting ? 'bg-gray-500' : 'bg-red-500 hover:bg-red-600'} text-white`}
          onClick={() => {
            if (!isDeleting) {
              deleteCollection();
            }
          }}
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete Collection'}
        </button>
      </div>
    </div>
  </div>
  
  
    // {/* </KeyboardAwareScrollView> */}
    
  )
}


export default EditCollection;